import { render, staticRenderFns } from "./NotificationCell.vue?vue&type=template&id=0e31196c&scoped=true"
import script from "./NotificationCell.vue?vue&type=script&lang=js"
export * from "./NotificationCell.vue?vue&type=script&lang=js"
import style0 from "./NotificationCell.vue?vue&type=style&index=0&id=0e31196c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31196c",
  null
  
)

export default component.exports